module.exports = "../../app/cells/pages/landing_xray/index/discipline_cell.rb";